const vehicleFields = ['model', 'make', 'colour']
let fieldsModified = false

function init() {
    let plateLookup = document.querySelector('.js-plate-lookup input')
    let timeout = null

    if (plateLookup) {
        plateLookup.addEventListener('input', (event) => {
            if (timeout) clearTimeout(timeout)
            timeout = setTimeout(() => {
                if (event.target.value && event.target.value.trim() != '')
                    getDetails(event.target.value)
            }, 1000)
        });

        vehicleFields.forEach(field => {
            document.querySelector(`.js-vehicle-field-${field} input`).addEventListener('change', (event) => {
                fieldsModified = true
            })
        })

        if (plateLookup.value && plateLookup.value.trim() != '') {
            getDetails(plateLookup.value)
        }
    }
}

function getDetails(plate) {
    return fetch(
        `/get-reg-details/${[encodeURI(plate)]}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.token}`
        }
    }
    )
        .then(res => res.json())
        .then(res => {
            console.log(res)
            if (!res.details || fieldsModified === true) {
                return
            }

            if (!res.details.make) {
                return
            }

            vehicleFields.forEach(field => {
                document.querySelector(`.js-vehicle-field-${field}`).classList.remove('hidden')
                document.querySelector(`.js-vehicle-field-${field} input`).value = res.details[field]
            })
        })
}

init()


// WEBPACK FOOTER //
// ./src/js/_dvla.js